<template>
  <div class="pa-10">
    <InstructorOjtOrgDataTable />
  </div>
</template>

<script>
import InstructorOjtOrgDataTable from "@/components/Utils/InstructorOjtOrgDataTable.vue";

export default {
  components: {
    InstructorOjtOrgDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
